import "./About.css";
import passport from "../../assets/passport.jpg";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { RiFoldersLine } from "react-icons/ri";

const About = () => {
  return (
    <section id="about">
      {/* <h2>Get To Know</h2> */}
      <h1>About Me</h1>

      <div className="container about__container">
        <div className="about__passport">
          <div className="about__passport-image">
            <img src={passport} alt="About Passport" />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>
                7 Years of Work Experience in Technical and Managerial roles
              </small>
            </article>

            <article className="about__card">
              <FiUsers className="about__icon" />
              <h5>Motivation</h5>
              <small>
                Focusing on Vue.js to create responsive Web applications, which can be packaged to run on Android/iOS devices.
              </small>
            </article>

            <article className="about__card">
              <RiFoldersLine className="about__icon" />
              <h5>Projects</h5>
              <small>
                Projects hosted on personal{" "}
                <a href="https://github.com/citixenken">GitHub</a> page
              </small>
            </article>
          </div>

          <p className="">
            I have a strong passion for learning and have acquired extensive
            knowledge in developing web applications through self-teaching and professional experience. My
            expertise lies primarily in Vue.js (Frontend) and Golang (Backend)
          </p>

          <a href="#contact" className="btn btn-primary">
            Let's Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
